import { apiDELETE, apiGET, apiPOST } from './api';

export const getReceivers = () => apiGET('/receivers');

export const createReceiver = receiver => apiPOST('/receivers', receiver);

export const getReceiverTypes = () => apiGET(`/receiver_types`);

export const deleteReceiver = (receiverId) => apiDELETE(`/receivers/${receiverId}`);
